/**
 * CCreated by n.rusev on 13/3/2019.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Grid component nests Rows, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to added to the component."
    }
];

export default documentedProperties;
